const getImagePath = index =>
  `/images/cases/design-991/wireframing/${index}.webp`

export const config = {
  title: 'wireframing:',
  description: (
    <>
      We built several app wireframes for the basic visual representation of its
      structure, layout, and functionality to allow designers, developers, and
      the client to visualize the application’s interface before the development
      process begins.
      <br />
      <br />
      Wireframes provided a simple and approximate image of the future
      e-learning platform outlook, features, navigation, and content placement.
      They focused primarily on the functionality and UX, not on the visual
      design. When creating the wireframes, we used paper sketches and Figma.
    </>
  ),
  images: [
    {
      src: getImagePath(0),
      alt: 'Multimedia mobile',
    },
    {
      src: getImagePath(1),
      alt: 'Login and sign up mobile',
    },
    {
      src: getImagePath(2),
      alt: 'Menus mobile',
    },
    {
      src: getImagePath(3),
      alt: 'Multimedia mobile',
    },
    {
      src: getImagePath(4),
      alt: 'Multimedia mobile',
    },
    {
      src: getImagePath(5),
      alt: 'Social mobile',
    },
    {
      src: getImagePath(6),
      alt: 'Blogs mobile',
    },
    {
      src: getImagePath(7),
      alt: 'Blogs mobile',
    },
    {
      src: getImagePath(8),
      alt: 'Blogs mobile',
    },
    {
      src: getImagePath(9),
      alt: 'Blogs mobile',
    },
  ],
}
